module.exports = __webpack_public_path__ + "static/media/buy.cf490500.svg";